import { ArrowRight, Gift } from 'lucide-react'
import { useEffect, useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { useAuth } from '../../context/AuthContext'
import {
  ARGUS_PENDING_PROMOTION_CODE_EVENT,
  pendingPromotionPath,
  readPendingPromotionCode,
} from '../../lib/pendingPromotionCode'

export default function PendingPromotionCodeBanner() {
  const { user, loading } = useAuth()
  const location = useLocation()
  const [code, setCode] = useState(() => readPendingPromotionCode())

  useEffect(() => {
    function refresh() {
      setCode(readPendingPromotionCode())
    }
    window.addEventListener(ARGUS_PENDING_PROMOTION_CODE_EVENT, refresh)
    window.addEventListener('storage', refresh)
    return () => {
      window.removeEventListener(ARGUS_PENDING_PROMOTION_CODE_EVENT, refresh)
      window.removeEventListener('storage', refresh)
    }
  }, [])

  if (
    loading ||
    !user ||
    !code ||
    location.pathname === '/promotions' ||
    location.pathname === '/account/referrals'
  ) {
    return null
  }

  const path = pendingPromotionPath(code)
  if (!path) return null

  return (
    <div className="border-hd-orange/30 bg-hd-dark/95 fixed inset-x-3 bottom-3 z-[91] mx-auto max-w-xl rounded-2xl border p-3 shadow-2xl backdrop-blur-xl sm:bottom-5 sm:p-4">
      <div className="flex items-center gap-3">
        <div className="border-hd-orange/25 bg-hd-orange/10 text-hd-orange flex h-10 w-10 shrink-0 items-center justify-center rounded-xl border">
          <Gift className="h-5 w-5" />
        </div>
        <div className="min-w-0 flex-1">
          <p className="text-hd-orange text-[9px] font-black tracking-[0.16em] uppercase">
            ARGUS invite
          </p>
          <p className="mt-0.5 truncate text-sm font-black">
            Your referral code {code} is waiting to be reviewed.
          </p>
        </div>
        <Link
          to={path}
          className="hd-btn-primary inline-flex min-h-10 shrink-0 items-center gap-2 px-3 text-xs font-black"
        >
          Review <ArrowRight className="h-4 w-4" />
        </Link>
      </div>
    </div>
  )
}
